<template>

    <section v-if="quoteRequest && quoteRequest.company">
        <div class="container">
            <div class="page-header" v-if="notAcceptedOrSubmitted" :class="{ 'has-alert': hasAutoCcdRecipients }">
                You've been invited to quote on "{{quoteRequest.title}}". Please review the information below and then let us know if you're interested...
            </div>
            <div class="auto-cc-alert" v-if="hasAutoCcdRecipients">
              This RFQ has also been sent to
              {{ quoteRequest.autoCcdRecipients.join(', ') }}.
              Please refer to your company's internal RFQ process to determine next steps.
            </div>
            <div class="columns ">
                <div class="column">
                    <div class="info-panel">
                        <h3 class="title title-info-panel is-6"><span v-show="false" class="fas fa-map-marker-alt"></span>Location</h3>
                        <address v-html="computedAddress"></address>
                    </div>
                </div>
                <div class="column">
                    <div class="info-panel">
                        <h3 class="title title-info-panel is-6">Deadline Date
                        </h3>
                        <span>{{dateDeadline}}</span>
                    </div>
                </div>
                <div class="column">
                    <div class="info-panel">
                        <h3 class="title title-info-panel is-6"><span v-show="false" class="fas fa-industry"></span>Builder Details
                        </h3>
                        <span>{{quoteRequest.company.name}}</span>
                        <address>
                            {{quoteRequest.company.address}}<br>
                            <span v-if="quoteRequest.company.phone"><span class="fas fa-phone"></span>&nbsp;&nbsp;<a v-bind:tel="quoteRequest.company.phone">{{quoteRequest.company.phone}}</a><br></span>
                            <span v-if="quoteRequest.company.email"><span class="fas fa-envelope"></span> <a v-bind:href="`mailto:${quoteRequest.company.email}`">&nbsp;&nbsp;{{quoteRequest.company.email}}</a></span>
                        </address>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>

export default {
  name: 'section-details',
  components: {
  },
  props: ['quoteRequest', 'dateDeadline', 'reopenVisible', 'dateSubmitted', 'token', 'step', 'stepReached'],
  mounted () {

  },
  data () {
    return {
      hasAutoCcdRecipients: this.quoteRequest.autoCcdRecipients && this.quoteRequest.autoCcdRecipients.length
    }
  },
  methods: {
  },
  computed: {
    computedAddress () {
      let address = ''
      if (this.quoteRequest) {
        const source = this.quoteRequest.job ? this.quoteRequest.job : this.quoteRequest.estimate
        if (source) {
          if (source.worksLocationAddress !== null) address += source.worksLocationAddress + '<br>'
          if (source.worksLocationCityTown !== null) address += source.worksLocationCityTown + '<br>'
          if (source.worksLocationState !== null) address += source.worksLocationState + ' '
          if (source.worksLocationPostCode !== null) address += source.worksLocationPostCode
        }
      }
      if (address === '') address = 'Address not provided'
      return address
    },
    notAcceptedOrSubmitted () {
      // Don't include opened... !
      // this.$store.state.data.recipient.quoteStatus === 'Opened'
      return (this.$store.state.data && this.$store.state.data.recipient && (this.$store.state.data.recipient.quoteStatus !== 'Submitted' && this.$store.state.data.recipient.quoteStatus !== 'Accepted'))
    }
  }
}
</script>
